<sbnb-hero-card
  *ngIf="plan"
  [active]="isCurrentValidPlan"
  [outlined]="plan.current_plan"
  [activeTooltip]="'Your current plan'"
  [useHover]="!isCurrentValidPlan">
  <div class="flex justify-between items-center flex-wrap gap-5 min-h-12">
    <h2 class="nomargin w-[125px]">
      {{ plan.plan }}
    </h2>

    <div class="flex flex-col items-center">
      <sbnb-button
        width="175px"
        [matTooltip]="disabedTooltip"
        *ngIf="!isCurrentValidPlan"
        [disabled]="isCurrentValidPlan || disabled"
        [type]="isProCard && !currentlyMogul ? 'primary-teal' : 'secondary'"
        (click)="selectPlan.emit({ planId: plan.plan_id, downgrade: isHostCard || currentlyMogul })">
        {{ subscribeWording }}
      </sbnb-button>
      <sbnb-button
        width="175px"
        [matTooltip]="'Make sure your operations are not interrupted and renew your subscription today.'"
        *ngIf="isCurrentValidPlan && subscription?.status === 'paused'"
        [type]="'primary'"
        (click)="selectPlan.emit({ planId: plan.plan_id, downgrade: isHostCard, resume: true })">
        Resume
      </sbnb-button>
      <sbnb-button
        width="175px"
        [matTooltip]="'Make sure your operations are not interrupted and renew your subscription today.'"
        *ngIf="isCurrentValidPlan && subscription?.status === 'pending_cancellation'"
        [type]="'primary'"
        (click)="selectPlan.emit({ planId: plan.plan_id, downgrade: isHostCard, renew: true })">
        Renew
      </sbnb-button>
    </div>
  </div>
  <ng-container *ngIf="isHostCard || isLegacyCard">
    <p class="text__large night">Includes:</p>
  </ng-container>
  <ng-container *ngIf="isProCard">
    <p class="text__large night">Everything in Host, plus:</p>
  </ng-container>
  <ng-container *ngIf="isMogulCard">
    <div class="mt-4" *ngIf="isMogulCard && !isCurrentValidPlan">
      Upgrade now or&nbsp;
      <a class="link" (click)="contactSales()">schedule a call to find out more!</a>
    </div>
    <p class="text__large night">Everything in Pro, plus:</p>
  </ng-container>

  <div class="flex flex-wrap justify-between" style="gap: 6px">
    <ul class="list">
      <li *ngFor="let feature of features.slice(0, 3)">{{ feature }}</li>
    </ul>
    <ul class="list">
      <li *ngFor="let feature of features.slice(3, 6)">{{ feature }}</li>
    </ul>
  </div>

  <ng-container *ngIf="isMogulCard">
    <p class="text__large italic night">Coming soon:</p>
    <div class="flex flex-wrap justify-between" style="gap: 6px">
      <ul class="list">
        <li *ngFor="let comingSoon of comingSoon.slice(0, 3)">{{ comingSoon }}</li>
      </ul>
      <ul class="list">
        <li *ngFor="let comingSoon of comingSoon.slice(3, 6)">{{ comingSoon }}</li>
      </ul>
    </div>
  </ng-container>
</sbnb-hero-card>
